const rules = [
  {
    groupName: 'User Services',
    functions: [
      'getUserId',
      'getUserStatus',
      'getUserProfileImage',
      'getLatestLoginProvider',
    ],
    requiredScopes: 'user:read',
  },
  {
    groupName: 'Asset Management',
    functions: [
      'Asset.checkPreloadStatus',
      'preloadAssets',
      'Asset.preload',
      'getAssetCollection',
      'checkPreloadAssetsStatus',
    ],
    requiredScopes: 'assets:manage',
  },
  {
    groupName: 'Media Services',
    functions: [
      'scanCode',
      'Sound.play',
      'Sound.stop',
      'Sound.on',
      'Sound.off',
    ],
    requiredScopes: 'native:mediaManagement',
  },
  {
    groupName: 'AR Services',
    functions: [
      'ARScene.deleteModel',
      'ARScene.start',
      'ARScene.end',
      'ARScene.showOverlay',
      'ARScene.updateContent',
    ],
    requiredScopes: 'native:arServices',
  },
  {
    groupName: 'Location Services',
    functions: ['getCurrentLocation'],
    requiredScopes: 'native:locationServices',
  },
]

// Public available to call
const noRules = [
  'checkCompatibility',
  'exchangeToken',
  'closeWebView',
  'reloadWebView',
  'acceptTutorial',
  'cancelTutorial',
  'registerAllMember',
  'register7App',
  'registerCustomer',
  'trackAnalytic',
  'navigateByNavPage',
  'openMyCoupon',
  'isPermissionAllowed',
  'requestPermission',
  'getMuid',
  'getAllMemberId',
  'Tutorial.accept',
  'Tutorial.cancel',
  'getEnvironment',
  'openPDPA'
]

export class ScopeValidation {
  private scope: string[]
  private isDebug: boolean

  constructor(isDebug = false) {
    this.scope = []
    this.isDebug = isDebug
  }

  setScope(scope: string[]) {
    this.scope = scope
  }

  validateScope(functionName: string) {
    if (noRules.includes(functionName)) {
      return true
    }

    const rule = rules.find((rule) => rule.functions.includes(functionName))
    if (!rule) {
      return false
    }

    const hasRequiredScope = this.scope.includes(rule.requiredScopes)
    if (this.isDebug) {
      console.log(
        `[DEBUG] ${
          hasRequiredScope ? '✅' : '❌'
        } Function "${functionName}" requires scope "${rule.requiredScopes}"`,
        {
          requiredScope: rule.requiredScopes,
          availableScopes: this.scope,
        }
      )
    }

    return hasRequiredScope
  }
}
